import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ArchiveIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue149'}</MuiIcon>
    );
}
